(function () {
	function getCssVarPx(varName) {
		const value = getComputedStyle(document.documentElement).getPropertyValue(varName);
		return parseInt(value, 10) || 0;
	}

	function findGalleryWithMediaCarousel() {
		const galleries = document.querySelectorAll('product-gallery');
		for (const gallery of galleries) {
			if (gallery.querySelector('media-carousel')) return gallery;
		}
		return null;
	}

	const headerHeight = getCssVarPx('--header-height');
  const isTest1Template = document.querySelector('[data-template="product-page-v2"]');
	const gallery = findGalleryWithMediaCarousel();
	if (!gallery) return;
  
	const product = gallery.closest('.product');
	if (!product) return;

	const galleryContainer = gallery.closest('.product-gallery-container');
	if (!galleryContainer) return;

	const buyButtons = document.querySelector('[data-block-id="buy_buttons"]');
	const buyButtonsY = buyButtons ? buyButtons.offsetTop : Infinity;

	function onScroll() {
		if (!window.matchMedia('(max-width: 768px)').matches) return;

		const scrollY = window.scrollY;
		const galleryTop = galleryContainer.offsetTop;
		const galleryHeight = galleryContainer.offsetHeight;
		const gallery75Percent = galleryTop + galleryHeight * 0.75;

    const shouldFix = isTest1Template
      ? scrollY >= gallery75Percent && scrollY + headerHeight < buyButtonsY
      : scrollY > headerHeight && scrollY + headerHeight < buyButtonsY;

    product.classList.toggle('is-fixed-gallery', shouldFix);
	}

	window.addEventListener('scroll', onScroll, { passive: true });
	onScroll();
})();
